import * as React from "react";
import { useState, useEffect } from "react";
import { AddressForm } from "./components/AddressForm";
import { Rewards } from "./components/Rewards";
import axios from "axios";
import zcoinLogo from "./zCoinInvert.png";
import "./App.css";
function App() {
  const [rewardsList, setRewardsList] = useState({});
  const [bnbPrice, setBnbPrice] = useState({});
  const [loading, setLoading] = useState(false);

  const getBnbPrice = async () => {
    try {
      const price = await axios.get(
        "https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd%2Ceur"
      );
      setBnbPrice({
        usd: price.data.binancecoin.usd,
        eur: price.data.binancecoin.eur,
      });
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    getBnbPrice();
    const timer = setInterval(() => {
      getBnbPrice();
    }, 60000); //update bnb price every minute
    return function cleanup() {
      clearInterval(timer);
    };
  }, []);

  return (
    <React.Fragment>
      <header className="header">
        <div className="zcoinLogoContainer">
          <img className="zcoinLogo" src={zcoinLogo} alt="zcoin-logo" />
        </div>
        <h1 className="headerTitle">Zcoin Rewards Tracker</h1>
        <a
          className="headerLink"
          target="_blank"
          rel="noopener noreferrer"
          href="https://lezcoin.fr"
        >
          lezcoin.fr
        </a>
      </header>
      <main>
        <AddressForm
          setRewardsList={setRewardsList}
          setLoading={setLoading}
          bnbPrice={bnbPrice}
        />
        {loading && (
          <div className="loaderContainer">
            <div className="loader"></div>
          </div>
        )}
        {!loading && Object.entries(rewardsList).length > 0 ? (
          <Rewards rewardsList={rewardsList} />
        ) : null}
      </main>
    </React.Fragment>
  );
}

export default App;
